import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@app/components/components.module';
import { MaintenanceDowntimeComponent } from '../_index';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [MaintenanceDowntimeComponent],
  imports: [CommonModule, ComponentsModule],
  exports: [MaintenanceDowntimeComponent],
})
export class MaintenanceDowntimeModule {}
